import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LoginComponent } from './share-modul/components/login/login.component';
import { SignupComponent } from "./share-modul/components/signup/signup.component";
import { ForgotPasswordComponent } from "./share-modul/components/forgot-password/forgot-password.component";
import { ResetPasswordComponent } from "./share-modul/components/reset-password/reset-password.component";
import { LoginGuard } from "./guard/auth-related.guard.component";
import {
  TermsAndConditionsComponent
} from "./share-modul/components/terms-and-conditions/terms-and-conditions.component";
import { LoginWithRefreshTokenComponent } from './share-modul/components/login-with-refresh-token/login-with-refresh-token.component';
import { ResetPasswordMobileComponent } from './share-modul/components/reset-password-mobile/reset-password-mobile.component';


const routes: Routes = [

  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, canActivate: [LoginGuard] },
  { path: 'login/:refresh-token', component: LoginWithRefreshTokenComponent},
  // { path: 'signup', component: SignupComponent, canActivate: [LoginGuard] },
  { path: 'forgot-password', component: ForgotPasswordComponent, canActivate: [LoginGuard] },
  { path: 'webuser/users', component: ResetPasswordComponent, canActivate: [LoginGuard] },
  { path: 'hostuser/users', component: ResetPasswordMobileComponent, canActivate: [LoginGuard] },
  { path: 'host/users', component: ResetPasswordMobileComponent, canActivate: [LoginGuard] },
  { path: 'mbluser/users', component: ResetPasswordMobileComponent, canActivate: [LoginGuard] },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent}
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
